import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTreeview,{ref:"tree",attrs:{"items":_vm.formatted,"selection-type":"leaf","selectable":"","dense":"","return-object":"","selected-color":"primary"},on:{"input":function($event){return _vm.$emit('input', _vm.selected)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }